import { createAxiosClientAnonymous, type AxiosInstance } from '@b2ag/axios'
import { i18n } from '@b2ag/locale'

class UsagesService {
  api: AxiosInstance

  constructor({ usagesApiHost }: { usagesApiHost: string }) {
    this.api = createAxiosClientAnonymous(`${usagesApiHost}/v1`, {
      timeout: 20000,
      i18n,
    })
  }

  async findByProductIdAndCropId(productId, cropId) {
    const response = await this.api.get('/usages', {
      params: {
        product_id: productId,
        crop_id: cropId,
      },
    })
    return response.data
  }
}

export default UsagesService
